"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadList = exports.exportList = exports.sherlockCheck = exports.getItem = exports.getItemActions = exports.getLastAction = exports.getListItems = exports.retryAction = exports.stopMassAction = exports.ignoreRule = exports.createMassAction = exports.getSurveys = exports.updateActionInterest = exports.updateField = exports.deleteItem = exports.createItemBulk = exports.createItem = exports.deleteShare = exports.shareList = exports.updateList = exports.getListsV2 = exports.getLists = exports.getList = exports.removeList = exports.createList = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var tokenStorage_1 = tslib_1.__importDefault(require("./lib/tokenStorage"));
var api_1 = tslib_1.__importDefault(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
var SIXTY_SECONDS = 60000;
var axiosInstance = axios_1.default.create({
    timeout: SIXTY_SECONDS,
    baseURL: process.env.REACT_APP_MASS_PROCESSOR_URL,
    responseType: 'json',
});
axiosInstance.interceptors.request.use(function (request) {
    request.headers.Authorization = tokenStorage_1.default.get();
    return request;
});
axiosInstance.interceptors.response.use(function (response) {
    if (response.data === undefined)
        return response;
    return response.data;
}, function (error) {
    return Promise.reject(error);
});
// List
var createList = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.name, name = _c === void 0 ? 'Unnamed list' : _c, _d = _b.type, type = _d === void 0 ? 'expert' : _d;
    return axiosInstance.post('/list', { name: name, type: type });
};
exports.createList = createList;
// @ts-ignore
var removeList = function (id) { return axiosInstance.delete('/list/' + id, { id: id }); };
exports.removeList = removeList;
var getList = function (id) { return axiosInstance.get('/list/' + id); };
exports.getList = getList;
var getLists = function () { return axiosInstance.get('/list?type=expert'); };
exports.getLists = getLists;
var getListsV2 = function (_a) {
    var offset = _a.offset, includeCount = _a.includeCount, nameFilter = _a.nameFilter;
    var qs = query_string_1.default.stringify({ offset: offset, includeCount: includeCount, nameFilter: nameFilter });
    return axiosInstance.get('/list-v2?' + qs);
};
exports.getListsV2 = getListsV2;
var updateList = function (_a) {
    var id = _a.id, data = _a.data;
    return axiosInstance.patch('/list/' + id, data);
};
exports.updateList = updateList;
var shareList = function (_a) {
    var id = _a.id, userId = _a.userId, email = _a.email, fullName = _a.fullName, picture = _a.picture, currentPosition = _a.currentPosition, lastName = _a.lastName, firstName = _a.firstName;
    return axiosInstance.post('/list/' + id + '/share', {
        userId: userId,
        email: email,
        fullName: fullName,
        picture: picture,
        currentPosition: currentPosition,
        lastName: lastName,
        firstName: firstName,
    });
};
exports.shareList = shareList;
var deleteShare = function (_a) {
    var id = _a.id, userId = _a.userId;
    return axiosInstance.post('/list/' + id + '/share/delete', { userId: userId });
};
exports.deleteShare = deleteShare;
// Item
var createItem = function (listId, data) { return axiosInstance.post('/item', { listId: listId, data: data }); };
exports.createItem = createItem;
var createItemBulk = function (listId, data) { return axiosInstance.post('/item/many', { listId: listId, data: data }); };
exports.createItemBulk = createItemBulk;
var deleteItem = function (itemId) { return axiosInstance.delete("/item/".concat(itemId)); };
exports.deleteItem = deleteItem;
var updateField = function (_a) {
    var id = _a.id, key = _a.key, value = _a.value;
    return axiosInstance.patch('/item/' + id, { key: key, value: value });
};
exports.updateField = updateField;
// Action
var updateActionInterest = function (_a) {
    var id = _a.id, emailActionId = _a.emailActionId, interested = _a.interested, unsubscribed = _a.unsubscribed, reason = _a.reason;
    axiosInstance.put('/action/interest', {
        id: id,
        emailActionId: emailActionId,
        interested: interested,
        unsubscribed: unsubscribed,
        reason: reason,
    });
};
exports.updateActionInterest = updateActionInterest;
// Survey
var getSurveys = function () { return axiosInstance.get('/survey'); };
exports.getSurveys = getSurveys;
var createMassAction = function (data) { return axiosInstance.post('/mass-action', data); };
exports.createMassAction = createMassAction;
var ignoreRule = function (_a, comment, rules) {
    var listItemId = _a.listItemId, actionId = _a.actionId;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, axiosInstance.post("/item/".concat(listItemId, "/ignore-rule"), {
                        comment: comment,
                        actionId: actionId,
                        rules: rules,
                    })];
                case 1:
                    _b.sent();
                    return [2 /*return*/, (0, exports.retryAction)(actionId)];
            }
        });
    });
};
exports.ignoreRule = ignoreRule;
var stopMassAction = function (id) { return axiosInstance.post("/mass-action/".concat(id, "/stop")); };
exports.stopMassAction = stopMassAction;
var retryAction = function (id) { return axiosInstance.post("/action/".concat(id, "/retry")); };
exports.retryAction = retryAction;
var getListItems = function (id, offset, itemId) {
    var itemIdSearch = itemId ? "&itemId=".concat(itemId) : '';
    return axiosInstance.get("/list/".concat(id, "/items?offset=") + offset + itemIdSearch);
};
exports.getListItems = getListItems;
var getLastAction = function (id) { return axiosInstance.get("/item/".concat(id, "/last-action")); };
exports.getLastAction = getLastAction;
var getItemActions = function (id) { return axiosInstance.get("/item/".concat(id, "/actions")); };
exports.getItemActions = getItemActions;
var getItem = function (id) { return axiosInstance.get("/item/".concat(id)); };
exports.getItem = getItem;
var sherlockCheck = function (id) { return axiosInstance.get("/item/".concat(id, "/sherlock")); };
exports.sherlockCheck = sherlockCheck;
var exportList = function (id) {
    return api_1.default.post("/api/export-athena-list/".concat(id)).then(function (response) { return response.data; });
};
exports.exportList = exportList;
var downloadList = function (data) {
    var url = data.url.concat("?token=".concat(localStorage.getItem('ngStorage-accessToken')));
    var link = document.createElement('a');
    link.href = url;
    link.download = data.filename;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};
exports.downloadList = downloadList;
